export default __webpack_public_path__ + "static/montserrat-v26-latin-ext-300-ba61f609269ea02981c6114774be7ec6.woff2";